
























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import ContentType from "@/models/porposal/contentTeype.Model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import LanguageService from "@/services/language.service";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
@Component
export default class ContentTypeTableComponent extends GenericBTable<ContentType> {
  
  created() {
    this.permissionValue = PermissionValue.TIPOCONTENIDO;
    this.tableConfig.controller = "ContentTypes";
    this.tableConfig.actions.customTemplate = true;
  }

  mounted() {
    this.formatColumns();
  }

 formatColumns() {
    let name = new BTableColumn("name", "table.name", true);
    let description = new BTableColumn("description", "table.description", true);
    this.tableConfig.insertColumns(name, description);
    this.tableConfig.actions.customTemplate = false;
    this.tableConfig.activeActions = this.permissionAccess.write;
    this.tableConfig.actions.customTemplate = this.permissionAccess.write;

  }

}
